import PropTypes from 'prop-types';

export default PropTypes.shape({
  trackEvent: PropTypes.func,
  getTrackingData: PropTypes.func,
});
